import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../../app/api";

// =====================================================
// SEND OTP
// =====================================================
export const sendOtp = createAsyncThunk(
  "auth/sendOtp",
  async (
    { username, password, login_type },
    { rejectWithValue }
  ) => {
    try {
      const response = await API.post(
        `/auth/${login_type}/login`,
        {
          username,
          password,
        }
      );

      return response.data;
    } catch (error) {
      console.error(
        "SEND OTP ERROR:",
        error
      );

      return rejectWithValue(
        error.response?.data || {
          message: "OTP send failed",
        }
      );
    }
  }
);

// =====================================================
// VERIFY OTP
// =====================================================
export const verifyOtp = createAsyncThunk(
  "auth/verifyOtp",
  async (
    { request_id, otp },
    { rejectWithValue }
  ) => {
    try {
      const payload = {
        request_id,
        verification_code: otp,
      };

      const response = await API.post(
        "/auth/verify-otp",
        payload
      );

      console.log(
        "VERIFY OTP API RESPONSE:",
        response.data
      );

      return response.data;
    } catch (error) {
      console.error(
        "VERIFY OTP ERROR:",
        error
      );

      return rejectWithValue(
        error.response?.data || {
          message: "OTP verification failed",
        }
      );
    }
  }
);

// =====================================================
// GET USER ROLE ID
// =====================================================
const getUserRoleId = (data) => {
  return (
    data?.user_role_id ??
    data?.user?.user_role_id ??
    data?.role_id ??
    data?.user?.role_id ??
    data?.userRoleId ??
    data?.user?.userRoleId ??
    null
  );
};

// =====================================================
// INITIAL STATE
// =====================================================
const initialState = {
  loading: false,

  error: null,

  otpSent: false,

  request_id:
    localStorage.getItem("request_id") || null,

  access_token:
    localStorage.getItem("access_token") || null,

  refresh_token:
    localStorage.getItem("refresh_token") || null,

  user:
    localStorage.getItem("user") || null,

  // ===================================================
  // ROLE
  // ===================================================
  user_role_id:
    localStorage.getItem("user_role_id") || null,
};

// =====================================================
// AUTH SLICE
// =====================================================
const authSlice = createSlice({
  name: "auth",

  initialState,

  reducers: {
    // =================================================
    // LOGOUT
    // =================================================
    logout: (state) => {
      state.loading = false;
      state.error = null;
      state.otpSent = false;

      state.request_id = null;

      state.access_token = null;

      state.refresh_token = null;

      state.user = null;

      state.user_role_id = null;

      // -----------------------------------------------
      // CLEAR LOCAL STORAGE
      // -----------------------------------------------
      localStorage.removeItem(
        "access_token"
      );

      localStorage.removeItem(
        "refresh_token"
      );

      localStorage.removeItem(
        "user"
      );

      localStorage.removeItem(
        "user_role_id"
      );

      localStorage.removeItem(
        "request_id"
      );

      localStorage.removeItem(
        "otpLogin"
      );
    },
  },

  extraReducers: (builder) => {
    builder

      // =================================================
      // SEND OTP - PENDING
      // =================================================
      .addCase(
        sendOtp.pending,
        (state) => {
          state.loading = true;

          state.error = null;
        }
      )

      // =================================================
      // SEND OTP - SUCCESS
      // =================================================
      .addCase(
        sendOtp.fulfilled,
        (state, action) => {
          state.loading = false;

          state.otpSent = true;

          const requestId =
            action.payload?.data?.request_id ||
            action.payload?.request_id ||
            action.payload?.result?.request_id;

          console.log(
            "REQUEST ID:",
            requestId
          );

          state.request_id =
            requestId || null;

          if (requestId) {
            localStorage.setItem(
              "request_id",
              String(requestId)
            );
          }
        }
      )

      // =================================================
      // SEND OTP - ERROR
      // =================================================
      .addCase(
        sendOtp.rejected,
        (state, action) => {
          state.loading = false;

          state.error =
            action.payload;
        }
      )

      // =================================================
      // VERIFY OTP - PENDING
      // =================================================
      .addCase(
        verifyOtp.pending,
        (state) => {
          state.loading = true;

          state.error = null;
        }
      )

      // =================================================
      // VERIFY OTP - SUCCESS
      // =================================================
      .addCase(
        verifyOtp.fulfilled,
        (state, action) => {
          state.loading = false;

          // ---------------------------------------------
          // API DATA
          // ---------------------------------------------
          const data =
            action.payload?.data ??
            action.payload ??
            {};

          console.log(
            "================================="
          );

          console.log(
            "VERIFY OTP FULL RESPONSE:",
            action.payload
          );

          console.log(
            "VERIFY OTP DATA:",
            data
          );

          // ---------------------------------------------
          // ACCESS TOKEN
          // ---------------------------------------------
          const accessToken =
            data?.access_token ??
            data?.accessToken ??
            "";

          state.access_token =
            accessToken || null;

          if (accessToken) {
            localStorage.setItem(
              "access_token",
              String(accessToken)
            );
          }

          // ---------------------------------------------
          // REFRESH TOKEN
          // ---------------------------------------------
          const refreshToken =
            data?.refresh_token ??
            data?.refreshToken ??
            "";

          state.refresh_token =
            refreshToken || null;

          if (refreshToken) {
            localStorage.setItem(
              "refresh_token",
              String(refreshToken)
            );
          }

          // ---------------------------------------------
          // USER NAME
          // ---------------------------------------------
          const userName =
            data?.user?.name ??
            data?.name ??
            "";

          state.user = userName;

          localStorage.setItem(
            "user",
            String(userName)
          );

          // ---------------------------------------------
          // USER ROLE ID
          // ---------------------------------------------
          const userRoleId =
            getUserRoleId(data);

          console.log(
            "FINAL USER ROLE ID:",
            userRoleId
          );

          // ---------------------------------------------
          // SAVE ROLE
          // ---------------------------------------------
          if (
            userRoleId !== null &&
            userRoleId !== undefined &&
            userRoleId !== ""
          ) {
            state.user_role_id =
              String(userRoleId);

            localStorage.setItem(
              "user_role_id",
              String(userRoleId)
            );
          } else {
            state.user_role_id = null;

            localStorage.removeItem(
              "user_role_id"
            );
          }

          console.log(
            "REDUX ROLE:",
            state.user_role_id
          );

          console.log(
            "LOCAL STORAGE ROLE:",
            localStorage.getItem(
              "user_role_id"
            )
          );

          console.log(
            "================================="
          );

          // ---------------------------------------------
          // REQUEST ID REMOVE
          // ---------------------------------------------
          state.request_id = null;

          localStorage.removeItem(
            "request_id"
          );
        }
      )

      // =================================================
      // VERIFY OTP - ERROR
      // =================================================
      .addCase(
        verifyOtp.rejected,
        (state, action) => {
          state.loading = false;

          state.error =
            action.payload;
        }
      );
  },
});

// =====================================================
// EXPORT
// =====================================================
export const { logout } =
  authSlice.actions;
export default authSlice.reducer;
